import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import DashboardInfo from './DashboardInfo';
import DashboardTable from './DashboardTable';
import useResponsive from '../../hooks/useResponsive';
import DashboardCharts from './DashboardCharts';
import { useNavigate } from 'react-router-dom';

const DashboardContent = () => {
  const theme = useTheme();
  const isSmall = useResponsive('down', 'sm', 'xl');
  const navigate = useNavigate();
  return (
    <Stack sx={{ padding: 2, marginTop: 20 }}>
      <DashboardInfo />
      <DashboardCharts />
      <Box
        sx={{
          background: theme.palette.common.white,
          paddingY: 3,
          paddingX: 2,
          margin: isSmall ? 0 : 2,
          borderRadius: '8px',
        }}
      >
        <Stack
          direction="row"
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography
            variant="subtitle2"
            color={'neutral'}
            sx={{ fontWeight: 400, fontFamily: 'Inter', paddingX: 3 }}
          >
            Employment History
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/employment')}
            sx={{
              width: 85,
              borderRadius: '2px',
              height: 35,
              background: '#2F66F4',
            }}
          >
            View all
          </Button>
        </Stack>
        <DashboardTable />
      </Box>
    </Stack>
  );
};

export default DashboardContent;
